'use client';

import { useSetAtom } from 'jotai';
import React, { useState } from 'react';
import Form from '../../components/Form/Form';
import { FormComponentData } from '../../components/Form/interfaces';
import isVacanciesModalOpen from '../../store/vacanciesForm';
import styles from './VacanciesFormModal.module.scss';
import { GAEmit, GAEvents } from '../../gtagHelper';

const VacanciesFormModal = () => {
  const setIsModalOpen = useSetAtom(isVacanciesModalOpen);

  const [nameValue, setNameValue] = useState<string>('');
  const [phoneValue, setPhoneValue] = useState<string>('');
  const [emailValue, setEmailValue] = useState<string>('');
  const [linkedInValue, setLinkedInValue] = useState<string>('');
  const [portfolioValue, setPortfolioValue] = useState<string>('');
  const [messageValue, setMessageValue] = useState<string>('');

  const clearForm = () => {
    setNameValue('');
    setPhoneValue('');
    setEmailValue('');
    setLinkedInValue('');
    setPortfolioValue('');
    setMessageValue('');
  };

  const formData: FormComponentData = {
    title: 'Join our **team**',
    description: 'While there are no vacancies at the moment, leave your info to be the first to get any updates.',
    fields: [
      {
        id: 'vacanciesNameField',
        name: 'vacanciesName',
        type: 'input',
        label: 'Enter your name',
        value: nameValue,
        setValue: setNameValue,
        errors: {
          required: 'Please enter your name',
        },
      },
      {
        id: 'vacanciesEmailField',
        name: 'vacanciesEmail',
        type: 'input',
        label: 'Enter your email',
        value: emailValue,
        setValue: setEmailValue,
        errors: {
          required: 'Please provide your email address',
          custom: [{
            condition: emailValue !== '' && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue),
            value: 'Please enter a valid email',
          }],
        },
      },
      {
        id: 'vacanciesPhoneField',
        name: 'vacanciesPhone',
        type: 'input',
        inputType: 'tel',
        label: 'Enter your phone',
        value: phoneValue,
        setValue: setPhoneValue,
        errors: {
          required: 'Please enter your phone',
          custom: [{
            condition: phoneValue !== '' && !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(phoneValue),
            value: 'Please enter a valid phone number',
          }],
        },
      },
      {
        id: 'vacanciesLinkedinField',
        name: 'vacanciesLinkedin',
        type: 'input',
        label: 'LinkedIn profile',
        value: linkedInValue,
        setValue: setLinkedInValue,
        errors: {
          required: 'Please enter your LinkedIn profile link',
          custom: [{
            condition: linkedInValue !== '' && !/https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9\-_]+\/?/.test(linkedInValue),
            value: 'Please enter valid LinkedIn profile link',
          }],
        },
      },
      {
        id: 'vacanciesPortfolioField',
        name: 'vacanciesPortfolio',
        type: 'input',
        label: 'Portfolio URL',
        value: portfolioValue,
        setValue: setPortfolioValue,
      },
      {
        id: 'vacanciesAboutField',
        name: 'vacanciesAbout',
        type: 'textarea',
        label: 'Tell us about yourself',
        value: messageValue,
        setValue: setMessageValue,
        errors: {
          required: 'Please tell us about yourself',
        },
      },
    ],
    submitData: {
      endpoint: 'contact-form-lead/no-vacancy',
      value: {
        name: nameValue,
        email: emailValue,
        phone: phoneValue,
        aboutYourself: messageValue,
        linkedinUrl: linkedInValue,
        portfolioUrl: portfolioValue,
      },
      successCallback: () => GAEmit(GAEvents.joinTeamFormSubmission),
    },
    openedModal: isVacanciesModalOpen,
  };

  return (
    <div className={styles.contactModal}>
      <button
        type='button'
        className={styles.closeButton}
        onClick={() => setIsModalOpen(false)}
      >
        <svg>
          <use
            xlinkHref='/media/menuClose.svg#menuCloseSVG'
            href='/media/menuClose.svg#menuCloseSVG'
          />
        </svg>
      </button>
      <Form
        data={formData}
        onSuccessSubmit={clearForm}
      />
    </div>
  );
};

export default VacanciesFormModal;
